// inactivity.service.ts
import { Injectable, NgZone } from '@angular/core';
import { fromEvent, merge, timer, Subscription } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { DialogService } from './dialog.service';

@Injectable({
  providedIn: 'root'
})
export class InactivityService {
  private inactivityTimer$!: Subscription;
  private readonly timeoutInMs = 12*60 * 60 * 1000; // 12 hours

  constructor(private http: HttpClient, private ngZone: NgZone,private dialogService: DialogService) {
    this.monitorActivity();
  }

  private monitorActivity() {
    const activityEvents = merge(
      fromEvent(document, 'mousemove'),
      fromEvent(document, 'keydown'),
      fromEvent(document, 'touchstart')
    );

    this.ngZone.runOutsideAngular(() => {
      this.inactivityTimer$ = activityEvents.pipe(
        switchMap(() => timer(this.timeoutInMs)),
        tap(() => {
          this.ngZone.run(() => this.callApiOnInactivity());
        })
      ).subscribe();
    });
  }

  private callApiOnInactivity() {
    this.dialogService.openDialog(
        'Session Timeout',
        'Your session has expired due to inactivity. For security reasons, please log in again to continue.'
      );
  }

  ngOnDestroy() {
    if (this.inactivityTimer$) {
      this.inactivityTimer$.unsubscribe();
    }
  }
}
